/*
 * @Description: 单元格编辑管理器
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
// useCellEditManager.js
import { ref, provide, inject, nextTick } from 'vue';

// 创建编辑管理器
export function createCellEditManager() {
  const activeCellId = ref(null); //当前cee唯一值
  const activeCellRef = ref(null); //当前cell 编辑的ref

  // 打开编辑状态
  const openEdit = (cellId, cellRef) => {
    // 先关闭当前激活的单元格
    if (activeCellId.value && activeCellId.value !== cellId) {
      closeCurrent();
    }

    // 设置新的激活单元格
    activeCellId.value = cellId;
    activeCellRef.value = cellRef;

    // 确保DOM更新后执行
    nextTick(() => {
      // 如果是同一个单元格再次点击，则可能是切换编辑模式
      if (activeCellId.value === cellId && activeCellRef.value) {
        activeCellRef.value?.openEdit();
      }
    });
  };

  // 关闭当前编辑状态
  const closeCurrent = () => {
    if (activeCellRef.value) {
      activeCellRef.value?.closeEdit();
    }
    activeCellId.value = null;
    activeCellRef.value = null;
  };

  // 检查某个单元格是否处于激活状态
  const isActive = (cellId) => {
    return activeCellId.value === cellId;
  };

  return {
    openEdit,
    closeCurrent,
    isActive
  };
}

// 提供编辑管理器
export function provideCellEditManager() {
  const manager = createCellEditManager();
  provide('cellEditManager', manager);
  return manager;
}

// 使用编辑管理器
export function useCellEditManager() {
  return inject('cellEditManager');
}
